import React from 'react';
import {designSystemToken, Body, Modal} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

export interface DeleteProjectModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  projectName: string;
  isLoading?: boolean;
}

function DeleteProjectModal({
  open,
  onClose,
  onDelete,
  projectName,
  isLoading = false,
}: DeleteProjectModalProps) {
  return (
    <Modal
      open={open}
      handleClose={onClose}
      showCloseButton
      textAlignment="left"
      footerAlignment="right"
      width="403px"
      header={translate('Delete this project?')}
      primaryButtonText={translate('Delete')}
      primaryButtonProps={{
        disabled: isLoading,
        isLoading,
      }}
      handlePrimaryButtonClick={onDelete}
      secondaryButtonText={translate('Cancel')}
      secondaryButtonProps={{
        disabled: isLoading,
      }}
      handleSecondaryButtonClick={onClose}
    >
      <Body
        size="lg"
        style={{color: designSystemToken('semantic.fg.secondary')}}
      >
        {translate(
          `This will permanently delete {projectName} and everything in it`,
          {projectName}
        )}
        .
        <br />
        {translate("This action can't be")}{' '}
        <Body
          component="span"
          size="lg"
          style={{
            fontWeight: 'bold',
            color: designSystemToken('semantic.fg.secondary'),
          }}
        >
          {translate('undone')}
        </Body>
        .
      </Body>
    </Modal>
  );
}

export default DeleteProjectModal;
